import React from 'react';
import {apiV2PayByLinkCancel} from '../../../../api/merchant/payByLink';
import {openPopupWindow, openPopupInfo} from '../../../../emitters/popup';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading/B';
import Popup from '../../../dumb/Popup/B';
import {
  detailedDataDisplayCtor,
  DetailedDataSecondaryItem
} from "../../../helpers/Display/DetailedData";
import {
  DisplayAmountMerchant,
  DisplayDataMerchant,
  DisplayDateDetailedMerchant,
  DisplayIdMerchant
} from "../../../helpers/Display/DataDisplay";
import {Box, Grid} from "@material-ui/core";
import {BtnBlueOutlined, BtnRedFilled} from "../../../helpers/Buttons";

module.exports = (data = {}, callback) => {
  const DataDisplay = detailedDataDisplayCtor({
    ItemComponent: DetailedDataSecondaryItem,
    containerProps: {},
    columnProps: {
      md: 3,
      sm: 6,
      xs: 12
    }
  });
  const itemsParamsList = [
    {
      title: 'Order ID',
      dataHandler: ({invoiceNumber}) => (
        <DisplayIdMerchant>{invoiceNumber}</DisplayIdMerchant>
      )
    },
    {
      title: 'Email',
      dataHandler: ({email}) => (
        <DisplayDataMerchant>{email}</DisplayDataMerchant>
      )
    },
    {
      title: 'Amount',
      dataHandler: ({fiatAmount, fiatCode}) => (
        <DisplayAmountMerchant
          amount={fiatAmount}
          symbol={fiatCode}
          type="fiat"
        />
      )
    },
    {
      title: 'Date',
      dataHandler: ({timeOfInvoice}) => (
        <DisplayDateDetailedMerchant date={timeOfInvoice} />
      )
    },
  ];

  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;

    const onCancel = () => {
      const invoiceNumber = data.invoiceNumber;

      setPopupState({
        loading: true,
      });
      apiV2PayByLinkCancel({
        id: data.invoiceId,
      }).finally((error) => {
        setPopupState({
          loading: false,
        });
        if (error) {
          return;
        }
        close();
        openPopupInfo([
          `Order ${invoiceNumber} cancelled`,
          'You can view the order details in the transaction history'
        ]);
        callback && callback();
      });
    }

    return (stateOfPopup) => {
      return (
        <Popup caption="Are you sure you want to cancel this link?">
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <Box mt="2.5rem">
              <DataDisplay
                data={data}
                itemsParamsList={itemsParamsList}
              />
            </Box>
            <Box maxWidth="60rem" mt="3.5rem">
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <BtnRedFilled onClick={onCancel}>
                    Cancel
                  </BtnRedFilled>
                </Grid>
                <Grid item md={6} xs={12}>
                  <BtnBlueOutlined onClick={close}>
                    Close
                  </BtnBlueOutlined>
                </Grid>
              </Grid>
            </Box>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
